
import DatePicker from "@/components/DatePicker.vue";
import Vue, { PropType } from "vue";
import {toLocalDateString} from "@/utils/UtcToDate";

let timedOutFunction: any;

// eslint-disable-next-line
const dateTimePicker: any = Vue.extend({
  props: {
    value: {
      type: Date as PropType<Date | null>,
    },
    label: {
      type: String,
      default: "Datum",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    month: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    notAllowedDates: {
      type: Array as PropType<Date[]>,
      default: () => [],
    },
    notAllowedInfo: {
      type: String,
      default: "Dieses Datum ist nicht erlaubt."
    },
  },
  data() {
    return {
      valueAsStr: "",
      rulesForLong: [
        (v: string) =>
           (!this.notAllowedDates.some( date =>  toLocalDateString(date) == v)) ||
            this.notAllowedInfo,

        (v: string) =>
          (v && v.length > 0 &&
          (/^\s*(3[01]|[12][0-9]|0?[1-9])\.(1[012]|0?[1-9])\.((?:18|19|20|21|22|23|24)\d{2})\s*$/g.test(
              v
            ))) ||
          "Eingabe ist kein valides Datum",
      ],
      rulesForShort: [
        (v: string) =>
            (v && v.length > 0  &&
                /^\s*(1[012]|0?[1-9])\.((?:18|19|20|21|22|23|24)\d{2})\s*$/g.test(
                    v
                )) ||
            "Eingabe ist kein valides Datum ",
      ],
    };
  },
  computed: {
    formattedValue: {
      get(): string {
        return this.valueAsStr;
      },
      set(val: string) {
        if (timedOutFunction) {
          clearTimeout(timedOutFunction);
        }
        timedOutFunction = setTimeout(() => {
          if (!val || val == null) {
            this.$emit("input", null);
            return;
          }
          if (
            val &&
            val.lastIndexOf(".") > -1 &&
            val.substr(val.lastIndexOf(".") + 1).length === 4
          ) {
            let [day, month, year] = val.split(".");
            if (this.month) {
              [month, year] = val.split(".");
              day = "01";
            }
            this.$emit(
              "input",
              new Date(
                `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`
              )
            );
          }
          if (val.length === 2 && !val.endsWith(".")) {
            val = val + ".";
          } else if (
            !this.month &&
            val.length === 5 &&
            !val.endsWith(".") &&
            val.lastIndexOf(".") !== 3
          ) {
            val = val + ".";
          }
          let [day, month, year] = val.split(".");
          if (this.month) {
            [month, year] = val.split(".");
            day = "01";
          }

          if (
            year &&
            month &&
            day &&
            day !== "0" &&
            month !== "0" &&
            year.length === 4
          ) {
            this.$emit("input", new Date(`${year}-${month}-${day}`));
          }
          if (
            year &&
            month &&
            day &&
            day !== "0" &&
            month !== "0" &&
            year.length === 2
          ) {
            this.$emit("input", new Date(`20${year}-${month}-${day}`));
          }
          if (!this.month && val.length <= 10) {
            this.valueAsStr = val;
          } else if (this.month && val.length <= 7) {
            this.valueAsStr = val;
          }
        }, 200);
      },
    },
    formattedValueForCalendar: {
      get(): string {
        try {
          if (this.value) {
            return this.value.toISOString().substr(0, 10);
          }
          return "";
        } catch (e) {
          return "";
        }
      },
      set(val: string) {
        this.$emit("input", new Date(val));
        this.$emit("change");
      },
    },
  },
  watch: {
    value: {
      handler() {
        if (this.value && !isNaN(this.value.getTime())) {
          const [year, month, day] = this.value
            .toISOString()
            .substr(0, 10)
            .split("-");
          if (this.month) {
            this.valueAsStr = `${month}.${year}`;
          } else {
            this.valueAsStr = `${day}.${month}.${year}`;
          }
        } else {
          this.valueAsStr = "";
        }
      },
      immediate: true,
    },
  },
  components: {
    DatePicker,
  },
});

export default dateTimePicker;
